import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import parseISO from "date-fns/parseISO";
import moment from "moment-timezone";

// Components
import Loader from "../../utils/Loader";
// import ShippingMethodItem from "./ShippingMethodItem";

// CSS
import "../../../css/react-select.css";

// State
import { setActiveCheckoutSection } from "../../../store/actions/checkout";
import { getPickupOptions, setPickupOption } from "../../../store/actions/pickup";

// Util
import {
	setCheckoutSectionActive as setCheckoutSectionActiveGA,
	setCheckoutSectionComplete as setCheckoutSectionCompleteGA,
} from "../../../utils/google-analytics";

class PickupSection extends Component {
	constructor(props) {
		super(props);

		this.state = {
			displayDate: '',
			pickupDateString: '',
			pickupTimeString: '',
			pickupDate: '',
			timeStart: '',
			timeEnd: '',
			timeArr: [],
		};
	}

	// ===================================
	//  LIFE CYCLE HOOKS
	// ===================================
	componentDidMount() {
		// if (!this.props.isStore || !this.props.isPickup) {
		// 	setCheckoutSectionCompleteGA(5.5);

		// 	// Set Order active
		// 	setCheckoutSectionActiveGA(6);
		// 	this.props.setActiveCheckoutSection("order");
		// 	return;
		// }
		this.getOptions();
	}

	// This method was left in and I dont to touch it and mess something up
	getOptions = () => {
		this.props.getPickupOptions().then((res) => {
			// If nothing is returned, bail!  No options available
			if (!res) return;

			// If this is set, the user has already made a selection.
			let { pickupSelected } = this.props;
		});
	};

	updateSelectedOption = (selection) => {
		this.setState({
			option: selection,
		});
	};

	handlePickupDateChange(date) {
		let dateString = moment(date, 'YYYY-MM-DD');
		dateString = dateString.format().substring(0, 10);
		this.setState({
			displayDate: date,
			pickupDateString: dateString,
			pickupDate: '',
			pickupTimeString: '',
		});
		this.determineTimeSlots(date)
	}

	// Might be a bit messy
	// This method finds the correct day of the week
	// Then push the times available - between a start and end time - as date objects to an array
	determineTimeSlots(date) {
		// Necessary to match the the day property in days array
		// Need to use index of the date we're working with to get the written day since the db's week starts on MONDAY D:
		// If theres ever a bug with this, like wrong times showing on the wrong day,
		// Check to see the order of the days of the week in db - if it starts on sunday, thats the (most likely) issue
		const daysOfTheWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
		const writtenDay = daysOfTheWeek[date.getDay()];
		let startTime = '';
		let endTime = '';
		let timeArr = [];
		// So every button will have a unique id/key so React can stop yelling
		let index = 0;
		this.props.days.forEach(element => {
			// console.log(element);
			// Go through every day of the week to find start & end times
			if (element.day === writtenDay) {
				if (element.start && element.end) {
					startTime = new Date("January 1, 2020 " + element.start);
					endTime = new Date("January 1, 2020 " + element.end);
					let offset = 30 * 1000 * 60;
					// Loop through startTime in endTime in half hour incrememnts - see offset var
					// If you need to change increment, change the first number in offset to how many minutes you need
					while (startTime <= endTime) {
						timeArr.push({ id: index, timeSlot: startTime });
						// Keep original start and end time for appointments by pushing BEFORE you create a new appointment time
						startTime = new Date(startTime.getTime() + offset);
						index++;
					}
				}
			}
		});
		this.setState({
			timeArr: timeArr
		});
	}

	concatDateTime(timeWithSeconds) {
		let pickupDate = this.state.pickupDateString + ' ' + timeWithSeconds;
		this.setState({
			pickupDate: pickupDate,
			pickupTimeString: timeWithSeconds,
		});
	}

	makeButtons(timeFromArr) {
		let formattedTime = moment(timeFromArr.timeSlot).format('h:mm a');
		let timeWithSeconds = moment(timeFromArr.timeSlot).format('HH:mm:ss');
		return (
			// onClick will break checkout without making it an arrow function, probably something to do with .bind(this)? Anyway leave it be pls
			<button
				className={"btn"}
				onClick={() => this.concatDateTime(timeWithSeconds)}
				key={timeFromArr.id}
			>
				<span>{formattedTime}</span>
			</button >
		)
	}

	handleSubmit = (event) => {
		event.preventDefault();

		this.props.setPickupOption(this.state).then(() => {
			// Set current section as complete
			setCheckoutSectionCompleteGA(5.5);

			// Set Order active
			setCheckoutSectionActiveGA(6);
			this.props.setActiveCheckoutSection("order");
		});
	};

	render() {
		const {
			pickupOptionsLoading,
			pickupOptionsError,
			options,
			isLoading,
			selectionError,
			max_days,
			max_appointments,
			days,
			closed
		} = this.props;
		return (
			<div>
				<div className="delivery-heading">
					<h2>Select your pickup date and time:</h2>
				</div>

				<div className="container">
					{pickupOptionsLoading ? (
						<Loader />
					) : pickupOptionsError ? (
						<div className="error top-margin">{pickupOptionsError.general}</div>
					) : (
								<React.Fragment>
									<DatePicker
										selected={this.state.displayDate}
										onChange={(date) => this.handlePickupDateChange(date)}
										excludeDates={closed ? getClosedDates(closed) : null}
										minDate={new Date()}
										maxDate={new Date().setDate(new Date().getDate() + max_days)}
										showDisabledMonthNavigation
										placeholderText="Click to pick a date"
									/>
									{/* Second ternary statement prevents the message from being shown if no date has been chosen yet */}
									<div className="container btn-time-container">
										{this.state.timeArr.length
											? this.state.timeArr.map(this.makeButtons.bind(this))
											: this.state.displayDate
												? <p>Sorry, no timeslots are available on the specified date</p>
												: null}
										{console.log(this.state)}
										{/* {this.state.timeArr.map(this.makeButtons.bind(this))} */}
									</div>


									{!!selectionError && (
										<div className="error top-margin">{selectionError.general}</div>
									)}

									<div className="container review-buttons">
										{this.state.pickupDate ?
											<button
												className={"btn" + (isLoading ? " loading" : "")}
												disabled={isLoading}
												onClick={this.state.pickupDate ? this.handleSubmit : null}
											>
												<span>Select Date</span>
											</button>
											: null}
									</div>
								</React.Fragment>
							)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		pickup: state.checkout.pickup,
		cartSubTotal: !!state.cart.sub_total ? state.cart.sub_total : null,
		pickupOptionsLoading:
			typeof state.pickup.isLoading === undefined ? 1 : state.pickup.isLoading,
		pickupOptionsError: !!state.pickup.error ? state.pickup.error : null,
		options: !!state.pickup.options ? state.pickup.options : [],
		selectionLoading: !!state.pickup.selectionLoading ? state.pickup.selectionLoading : 0,
		selectionError: !!state.pickup.selectionError ? state.pickup.selectionError : null,
		max_days: state.pickup.max_days,
		max_appointments: state.max_appointments,
		closed: state.pickup.closed,
		days: state.pickup.days,
		isStore: state.checkout.isStore,
		isPickup: state.cart.is_pickup,
	};
};

const getClosedDates = (closed) => {
	let closedDates = [];
	closed.forEach(element => {
		const properDay = parseISO(element.day, 1);
		closedDates.push(properDay);
	});
	return closedDates;
}

export default connect(
	mapStateToProps,
	{
		getPickupOptions,
		setPickupOption,
		setActiveCheckoutSection,
		setCheckoutSectionActiveGA,
	}
)(PickupSection);



// WEBPACK FOOTER //
// ./src/components/checkout/pickup/PickupSection.js